import api from "./api";
import type {
  IEstoqueItensResponse,
  IEstoqueMovResponse,
  IEstoqueResumo,
  TipoMovimentacaoEstoque,
} from "interfaces/loja/estoque";

/** GET /loja/estoque/resumo */
export async function obterResumoEstoque(params?: { limiteBaixo?: number }) {
  const search = new URLSearchParams();
  if (params?.limiteBaixo != null) {
    search.set("limiteBaixo", String(params.limiteBaixo));
  }
  const qs = search.toString();
  const { data, status } = await api.get<IEstoqueResumo>(
    `/loja/estoque/resumo${qs ? `?${qs}` : ""}`
  );
  return { data, status } as { data: IEstoqueResumo; status: number };
}

/** GET /loja/estoque/itens */
export async function listarItensEstoque(params?: {
  page?: number;
  limit?: number;
  query?: string;
  somenteBaixo?: boolean;
  limiteBaixo?: number;
}) {
  const search = new URLSearchParams();
  if (params?.page != null) search.set("page", String(params.page));
  if (params?.limit != null) search.set("limit", String(params.limit));
  if (params?.query?.trim()) search.set("query", params.query.trim());
  if (params?.somenteBaixo === true) search.set("somenteBaixo", "true");
  if (params?.limiteBaixo != null) {
    search.set("limiteBaixo", String(params.limiteBaixo));
  }
  const qs = search.toString();
  const { data, status } = await api.get<IEstoqueItensResponse>(
    `/loja/estoque/itens${qs ? `?${qs}` : ""}`
  );
  return { data, status } as { data: IEstoqueItensResponse; status: number };
}

/** GET /loja/estoque/movimentacoes */
export async function listarMovimentacoesEstoque(params?: {
  page?: number;
  limit?: number;
  tipo?: TipoMovimentacaoEstoque;
  sku?: string;
  dataInicio?: string;
  dataFim?: string;
}) {
  const search = new URLSearchParams();
  if (params?.page != null) search.set("page", String(params.page));
  if (params?.limit != null) search.set("limit", String(params.limit));
  if (params?.tipo) search.set("tipo", params.tipo);
  if (params?.sku?.trim()) search.set("sku", params.sku.trim());
  if (params?.dataInicio) search.set("dataInicio", params.dataInicio);
  if (params?.dataFim) search.set("dataFim", params.dataFim);
  const qs = search.toString();
  const { data, status } = await api.get<IEstoqueMovResponse>(
    `/loja/estoque/movimentacoes${qs ? `?${qs}` : ""}`
  );
  return { data, status } as { data: IEstoqueMovResponse; status: number };
}

/** POST /loja/estoque/ajuste */
export async function aplicarAjusteEstoque(body: {
  variacaoId?: string;
  produtoId?: string;
  delta: number;
  observacao: string;
}) {
  const { data, status } = await api.post<{
    ok: true;
    novoEstoque: number;
    movimentacaoId: string;
  }>("/loja/estoque/ajuste", body);
  return { data, status };
}
